import type { Dict } from "../types";

export const openingHours: Dict = {
  en: {

    // OpeningHoursView

    // Exceptional Closures
    "OpeningHours.exceptionalClosures": "Exceptional Closures",
    "OpeningHours.exceptionalClosuresDescription": "Manage holidays, vacations and occasional unavailabilities",
    "OpeningHours.createOpeningHere": "Open exceptionally",
    "OpeningHours.createClosureHere": "Close exceptionally",
    "OpeningHours.allMonthButton": "Whole month",
    "OpeningHours.entriesThisMonth": "{n} entries this month",
    "OpeningHours.entryThisMonth": "{n} entry this month",
    "OpeningHours.entriesOnDay": "{n} entries on this day",
    "OpeningHours.entryOnDay": "{n} entry on this day",
    "OpeningHours.hairdresserSubtitle": "Set the schedule for {name}.",
    "OpeningHours.allClosedWarning": "At least one day must be open in a week.",
    "OpeningHours.degenerateDay": "End time must be after start time.",
    "OpeningHours.degenerateDayNamed": "Fix this day before saving:",
    "OpeningHours.degenerateDayEmployee": "{name}: fix {day} ({week}) before saving, the end time must be after the start time.",
    "OpeningHours.violationLineEnd": "{name} works {day} from {empStart} to {empEnd} in {week}, while the salon closes at {salonEnd}.",
    "OpeningHours.violationLineStart": "{name} works {day} from {empStart} to {empEnd} in {week}, while the salon opens at {salonStart}.",
    "OpeningHours.violationLineBoth": "{name} works {day} from {empStart} to {empEnd} in {week}, while the salon is open from {salonStart} to {salonEnd}.",
    "OpeningHours.violationMore": "And {n} more.",
    "OpeningHours.violationMoreOne": "And {n} more.",
    "OpeningHours.staleStateRefuseSave": "Your local hours got out of sync with the server. We refreshed them. Please review and click Save again.",
    "OpeningHours.changedElsewhere": "Opening hours were changed elsewhere ({who}).",
    "OpeningHours.keepMyEdits": "Keep my edits",
    "OpeningHours.reload": "Reload",
    "OpeningHours.salonScope": "salon hours",
    "OpeningHours.saveRefusedStale": "Not saved. Someone changed these hours while you were editing. Check the banner at the top, then reload or keep your edits.",
    "OpeningHours.removedEmployeeFallback": "a removed employee",
    "OpeningHours.addClosure": "Add",
    "OpeningHours.entireSalon": "Entire salon",
    "OpeningHours.allDay": "Full day",
    "OpeningHours.noClosures": "No scheduled closures",
    "OpeningHours.closureDeleted": "Closure deleted successfully",
    "OpeningHours.confirmDeleteClosure": "Delete closure?",
    "OpeningHours.confirmDeleteClosureDescription": "This closure will be permanently removed.",
    "OpeningHours.deleteCoversDates": "This entry covers {n} dates, from {from} to {to}.",
    "OpeningHours.deleteCoversWholeSalon": "It applies to the whole salon.",
    "OpeningHours.deleteCoversEmployees": "It applies to {n} employees.",
    "OpeningHours.deleteRowCount": "All {n} lines will be deleted.",
    "OpeningHours.searchPlaceholder": "Search by date or reason...",
    "OpeningHours.filterByMonth": "Month",
    "OpeningHours.allMonths": "All months",
    "OpeningHours.currentMonth": "This month",
    "OpeningHours.nextMonth": "Next month",
    "OpeningHours.next3Months": "Next 3 months",
    "OpeningHours.filterByEmployee": "Employee",
    "OpeningHours.allEmployees": "All employees",
    "OpeningHours.salonOnly": "Entire salon",
    "OpeningHours.filterByType": "Type",
    "OpeningHours.allTypes": "All types",
    "OpeningHours.fullDayOnly": "Full day",
    "OpeningHours.partialOnly": "Time range",
    "OpeningHours.closuresFound": "closure(s)",
    "OpeningHours.loadMore": "Load more",
    "OpeningHours.remaining": "remaining",
    "OpeningHours.employees": "employees",
    "OpeningHours.everyWeek": "every week",
    "OpeningHours.everyMonth": "every month",
    "OpeningHours.everyNWeeks": "every {n} weeks",
    "OpeningHours.everyNMonths": "every {n} months",
    "OpeningHours.dates": "dates",
    "OpeningHours.until": "until",
    "OpeningHours.variedHours": "varied hours",
    "OpeningHours.mixedKind": "Opening and modified hours",
    "OpeningHours.editException": "Edit",
    "OpeningHours.deleteException": "Delete",
    "OpeningHours.add": "Add",

    // Exceptional Openings
    "OpeningHours.exceptionalOpenings": "Exceptional Openings",
    "OpeningHours.exceptionalOpeningsDescription": "Open on days normally closed (holidays, special events)",
    "OpeningHours.addOpening": "Add",
    "OpeningHours.noOpenings": "No exceptional openings scheduled",
    "OpeningHours.openingDeleted": "Exceptional opening deleted successfully",
    "OpeningHours.confirmDeleteOpening": "Delete exceptional opening?",
    "OpeningHours.confirmDeleteOpeningDescription": "This exceptional opening will be permanently removed.",
    "OpeningHours.openingsFound": "opening(s)",
    "ExceptionalOpening.addTitle": "Add exceptional opening",
    "ExceptionalOpening.editTitle": "Edit exceptional opening",
    "ExceptionalOpening.dateLabel": "Date",
    "ExceptionalOpening.dateValidation": "Please select a day that is normally closed",
    "ExceptionalOpening.hoursLabel": "Opening hours",
    "ExceptionalOpening.hoursSourceEmployee": "Based on {name}'s usual {day} hours.",
    "ExceptionalOpening.hoursSourceSalon": "Based on the salon's {day} hours.",
    "ExceptionalOpening.hoursSourceDefault": "Default hours, please check them.",
    "ExceptionalOpening.reasonLabel": "Reason (optional)",
    "ExceptionalOpening.reasonPlaceholder": "e.g., Special event, Extra availability...",
    "ExceptionalOpening.recurring": "Recurring",
    "ExceptionalOpening.recurringDescription": "Repeat this opening on multiple dates",
    "ExceptionalOpening.repeatEvery": "Repeat every",
    "ExceptionalOpening.weeks": "week(s)",
    "ExceptionalOpening.months": "month(s)",
    "ExceptionalOpening.until": "Until",
    "ExceptionalOpening.willCreate": "Will create",
    "ExceptionalOpening.openings": "opening(s)",
    "ExceptionalOpening.saved": "Exceptional opening saved successfully",
    "ExceptionalOpening.saveError": "Failed to save exceptional opening",
    "ExceptionalOpening.onlyClosedDays": "Only normally closed days can be selected",
    "ExceptionalOpening.conflictItemAll": "All employees on {date}",
    "ExceptionalOpening.conflictItemOne": "{name} on {date}",
    "ExceptionalOpening.conflictToastOne": "Already open: {label}. Edit the existing entry from the calendar.",
    "ExceptionalOpening.conflictToastMany": "{count} openings already exist (e.g. {label}). Edit from the calendar.",
    "ExceptionalOpening.replaceTitle": "An opening already exists",
    "ExceptionalOpening.replaceDescOne": "An exceptional opening already exists for {label} ({existing}). Replace it with {new}?",
    "ExceptionalOpening.replaceDescMany": "{count} openings already exist for these dates. Replace them with the new hours ({new})?",
    "ExceptionalOpening.replaceConfirm": "Replace",
    "ExceptionalOpening.groupManagement": "Exceptional Opening Group",
    "ExceptionalOpening.groupDialogDescription":
      "Every line covered by this opening. Select the ones you want to remove, or edit one on its own.",
    "ExceptionalOpening.employeesCovered": "Employees Covered",
    "ExceptionalOpening.confirmDeleteSelectedDescription": "Are you sure you want to delete the selected exceptional openings?",
    "ExceptionalOpening.deleteSuccessMultiple": "exceptional openings deleted",
    "OpeningHours.groupEditHeading": "Edit hours and reason for this entry",
    "OpeningHours.groupEditApplyHint": "Applies to all {n} rows below.",
    "OpeningHours.groupEditApplyHintOne": "Applies to the row below.",
    "OpeningHours.selectAtLeastOneRow": "Select at least one row",
    "OpeningHours.exceptionalOpening": "Exceptional Opening",

    // Exceptional Hours (modify hours on open days)
    "OpeningHours.exceptionalHours": "Exceptional Hours",
    "OpeningHours.exceptionalHoursDescription": "Modify operating hours on days that are already open",
    "OpeningHours.tabSchedule": "Schedule",
    "OpeningHours.tabExceptions": "Exceptions",
    "OpeningHours.tabEmployees": "Per employee",
    "OpeningHours.headerSubtitle": "Salon hours, per-employee schedules and exceptions.",
    "OpeningHours.tileOpenDays": "Open days",
    "OpeningHours.tileIndividual": "Per-employee hours",
    "OpeningHours.tileEnabled": "On",
    "OpeningHours.tileDisabled": "Off",
    "OpeningHours.tileExceptionalDays": "Exceptional days",
    "OpeningHours.tileClosures": "Closures",
    "OpeningHours.addHours": "Add",
    "OpeningHours.noHours": "No exceptional hours scheduled",
    "OpeningHours.modifiedHours": "Modified",
    "OpeningHours.hoursFound": "exceptional hour(s)",
    "OpeningHours.confirmDeleteHours": "Delete exceptional hours?",
    "OpeningHours.confirmDeleteHoursDescription": "This action cannot be undone.",
    "OpeningHours.hoursDeleted": "Exceptional hours deleted successfully",
    "ExceptionalHours.addTitle": "Add exceptional hours",
    "ExceptionalHours.editTitle": "Edit exceptional hours",
    "ExceptionalHours.normalHours": "Normal hours",
    "ExceptionalHours.newHours": "New hours",
    "ExceptionalHours.onlyOpenDays": "Only normally open days can be selected",
    "ExceptionalHours.reasonPlaceholder": "e.g., Special event, Extended hours...",
    "ExceptionalDays.title": "Exceptional Days",
    "ExceptionalDays.description": "Manage special openings and modified hours",
    "ExceptionalDays.addTitle": "Add exceptional day",
    "ExceptionalDays.editTitle": "Edit exceptional day",
    "ExceptionalDays.badgeOpening": "Special opening",
    "ExceptionalDays.badgeExtended": "Modified hours",
    "ExceptionalDays.dayNormallyClosed": "This day is normally closed",
    "ExceptionalDays.dayNormallyOpen": "This day is normally open",
    "ExceptionalDays.empty": "No exceptional days scheduled",
    "ExceptionalDays.count": "exceptional day(s)",
    "ExceptionalDays.filterOpenings": "Special openings",
    "ExceptionalDays.filterExtended": "Modified hours",

    // OpeningHours
    "OpeningHours.title": "Opening Hours",
    "OpeningHours.subtitle": "Set your salon's weekly schedule. Toggle days on/off and adjust hours.",
    "OpeningHours.monday": "Monday",
    "OpeningHours.tuesday": "Tuesday",
    "OpeningHours.wednesday": "Wednesday",
    "OpeningHours.thursday": "Thursday",
    "OpeningHours.friday": "Friday",
    "OpeningHours.saturday": "Saturday",
    "OpeningHours.sunday": "Sunday",
    "OpeningHours.start": "Start time",
    "OpeningHours.end": "End time",
    "OpeningHours.to": "to",
    "OpeningHours.closed": "Closed",

    // Rotating Schedules
    "Schedule.weekLabel": "Week",
    "Schedule.addWeek": "Add a week",
    "Schedule.removeWeek": "Remove this week",
    "Schedule.removeWeekConfirm": "Are you sure you want to remove this week from the rotation?",
    "Schedule.cycleStart": "Cycle start date",
    "Schedule.cycleStartMondayOnly": "The cycle always starts on a Monday.",
    "Schedule.currentWeek": "Current",
    "Schedule.rotatingSchedule": "Rotating schedule",
    "Schedule.weekCount": "week rotation",
    "Schedule.autoCalculate": "Auto-calculate from schedule",
    "Schedule.removeWeekTitle": "Delete {week}?",
    "Schedule.removeWeekDescription": "Its 7 days will be lost.",
    "Schedule.removeWeekWithEmployees": "Its 7 days will be lost, for the salon and for {n} employees.",
    "Schedule.removeWeekWithEmployee": "Its 7 days will be lost, for the salon and for {n} employee.",
    "Schedule.rotationIntroTitle": "Set up an alternating schedule?",
    "Schedule.rotationIntroDescription": "A rotation repeats week after week, forever. For a one-off opening or closing, use the Exceptions tab instead.",
    "Schedule.rotationIntroWeekOne": "The week of Monday {date} will be week A.",
    "Schedule.rotationIntroConfirm": "Add the week",
    "OpeningHours.cycleStartInFuture": "The cycle start date is in the future for {name}. Please choose this week's Monday or an earlier one.",
    "OpeningHours.cycleStartInFutureSalon": "The salon's cycle start date is in the future. Please choose this week's Monday or an earlier one.",
    "OpeningHours.theSalon": "the salon",
    "OpeningHours.conflictingOpeningsTitle": "Exceptional openings now fall on open days",
    "OpeningHours.conflictingOpeningsDescription": "An exceptional opening always replaces the usual hours. If you keep them, these days will follow their own hours, not your new schedule.",
    "OpeningHours.conflictingOpeningsNoPermission": "You are not allowed to manage exceptional days. Ask the owner to remove these openings from the Exceptions tab.",
    "OpeningHours.conflictingOpeningsLineOne": "{name}: 1 exceptional opening now falls on an open day{differ}.",
    "OpeningHours.conflictingOpeningsLine": "{name}: {n} exceptional openings now fall on open days{differ}.",
    "OpeningHours.conflictingOpeningsDifferSingle": ", with different hours",
    "OpeningHours.conflictingOpeningsDifferOne": ", 1 of them with different hours",
    "OpeningHours.conflictingOpeningsDiffer": ", {m} of them with different hours",
    "OpeningHours.conflictingOpeningsRemove": "Remove these openings",
    "OpeningHours.conflictingOpeningsKeep": "Keep them",
    "OpeningHours.conflictingOpeningsRemoveFailed": "Your hours were saved, but the exceptional openings could not be removed. Please remove them from the Exceptions tab.",
    "OpeningHours.personOverlap": "This time range overlaps {start} to {end} at {location}. {name} cannot be in two places at once.",
    "OpeningHours.personGridSubtitle": "Hours of {name} in all of their locations. Each time range belongs to a location.",
    "OpeningHours.personAddSlot": "Time range",
    "OpeningHours.personAddSlotAt": "Add a time range at {location}",
    "OpeningHours.personSlotLocation": "Location of this time range",
    "OpeningHours.personSlotLocked": "You cannot change the hours of {location}.",
    "OpeningHours.personRemoveSlot": "Remove this time range",
    "OpeningHours.personWeekCountLocked": "Only someone who can manage all of these locations can add or remove a week.",
    "OpeningHours.personPartialSave": "Hours of {name} saved for {saved}. Not saved for {failed}: please try again.",
    "OpeningHours.personNoneSaved": "Hours of {name} not saved for {failed}: please try again.",
    "OpeningHours.personOtherLocation": "Other location",
    "OpeningHours.personLoadFailed": "The hours of your staff's other locations could not be read.",
  },
  fr: {

    // OpeningHoursView

    // Exceptional Closures
    "OpeningHours.exceptionalClosures": "Fermetures exceptionnelles",
    "OpeningHours.exceptionalClosuresDescription": "Gérez les jours fériés, vacances et indisponibilités ponctuelles",
    "OpeningHours.createOpeningHere": "Ouvrir exceptionnellement",
    "OpeningHours.createClosureHere": "Fermer exceptionnellement",
    "OpeningHours.allMonthButton": "Tout le mois",
    "OpeningHours.entriesThisMonth": "{n} entrées ce mois-ci",
    "OpeningHours.entryThisMonth": "{n} entrée ce mois-ci",
    "OpeningHours.entriesOnDay": "{n} entrées ce jour-là",
    "OpeningHours.entryOnDay": "{n} entrée ce jour-là",
    "OpeningHours.hairdresserSubtitle": "Définissez l'horaire pour {name}.",
    "OpeningHours.allClosedWarning": "Au moins un jour doit être ouvert dans une semaine.",
    "OpeningHours.degenerateDay": "L'heure de fin doit être après l'heure de début.",
    "OpeningHours.degenerateDayNamed": "Corrigez ce jour avant d'enregistrer :",
    "OpeningHours.degenerateDayEmployee": "{name} : corrigez le {day} ({week}) avant d'enregistrer, l'heure de fin doit être après l'heure de début.",
    "OpeningHours.violationLineEnd": "{name} travaille le {day} de {empStart} à {empEnd} en {week}, alors que le salon ferme à {salonEnd}.",
    "OpeningHours.violationLineStart": "{name} travaille le {day} de {empStart} à {empEnd} en {week}, alors que le salon ouvre à {salonStart}.",
    "OpeningHours.violationLineBoth": "{name} travaille le {day} de {empStart} à {empEnd} en {week}, alors que le salon est ouvert de {salonStart} à {salonEnd}.",
    "OpeningHours.violationMore": "Et {n} autres.",
    "OpeningHours.violationMoreOne": "Et {n} autre.",
    "OpeningHours.staleStateRefuseSave": "Vos heures locales étaient désynchronisées avec le serveur. Nous les avons rafraîchies, veuillez vérifier et cliquer sur Enregistrer de nouveau.",
    "OpeningHours.changedElsewhere": "Les horaires ont été modifiés ailleurs ({who}).",
    "OpeningHours.keepMyEdits": "Garder ma saisie",
    "OpeningHours.reload": "Recharger",
    "OpeningHours.salonScope": "heures du salon",
    "OpeningHours.saveRefusedStale": "Enregistrement refusé. Quelqu'un a modifié ces horaires pendant votre saisie. Regardez le bandeau en haut, puis rechargez ou gardez votre saisie.",
    "OpeningHours.removedEmployeeFallback": "un employé retiré",
    "OpeningHours.addClosure": "Ajouter",
    "OpeningHours.entireSalon": "Tout le salon",
    "OpeningHours.allDay": "Journée complète",
    "OpeningHours.noClosures": "Aucune fermeture programmée",
    "OpeningHours.closureDeleted": "Fermeture supprimée avec succès",
    "OpeningHours.confirmDeleteClosure": "Supprimer la fermeture ?",
    "OpeningHours.confirmDeleteClosureDescription": "Cette fermeture sera définitivement supprimée.",
    "OpeningHours.deleteCoversDates": "Cette entrée couvre {n} dates, du {from} au {to}.",
    "OpeningHours.deleteCoversWholeSalon": "Elle s'applique à tout le salon.",
    "OpeningHours.deleteCoversEmployees": "Elle s'applique à {n} employés.",
    "OpeningHours.deleteRowCount": "Les {n} lignes seront supprimées.",
    "OpeningHours.searchPlaceholder": "Rechercher par date ou raison...",
    "OpeningHours.filterByMonth": "Mois",
    "OpeningHours.allMonths": "Tous les mois",
    "OpeningHours.currentMonth": "Ce mois-ci",
    "OpeningHours.nextMonth": "Mois prochain",
    "OpeningHours.next3Months": "3 prochains mois",
    "OpeningHours.filterByEmployee": "Employé",
    "OpeningHours.allEmployees": "Tous les employés",
    "OpeningHours.salonOnly": "Tout le salon",
    "OpeningHours.filterByType": "Type",
    "OpeningHours.allTypes": "Tous les types",
    "OpeningHours.fullDayOnly": "Journée complète",
    "OpeningHours.partialOnly": "Plage horaire",
    "OpeningHours.closuresFound": "fermeture(s)",
    "OpeningHours.loadMore": "Voir plus",
    "OpeningHours.remaining": "restantes",
    "OpeningHours.employees": "employés",
    "OpeningHours.everyWeek": "toutes les semaines",
    "OpeningHours.everyMonth": "tous les mois",
    "OpeningHours.everyNWeeks": "toutes les {n} semaines",
    "OpeningHours.everyNMonths": "tous les {n} mois",
    "OpeningHours.dates": "dates",
    "OpeningHours.until": "jusqu'au",
    "OpeningHours.variedHours": "horaires variés",
    "OpeningHours.mixedKind": "Ouverture et horaire modifié",
    "OpeningHours.editException": "Modifier",
    "OpeningHours.deleteException": "Supprimer",
    "OpeningHours.add": "Ajouter",

    // Exceptional Openings
    "OpeningHours.exceptionalOpenings": "Ouvertures exceptionnelles",
    "OpeningHours.exceptionalOpeningsDescription": "Ouvrir les jours normalement fermés (jours fériés, événements spéciaux)",
    "OpeningHours.addOpening": "Ajouter",
    "OpeningHours.noOpenings": "Aucune ouverture exceptionnelle programmée",
    "OpeningHours.openingDeleted": "Ouverture exceptionnelle supprimée avec succès",
    "OpeningHours.confirmDeleteOpening": "Supprimer l'ouverture exceptionnelle ?",
    "OpeningHours.confirmDeleteOpeningDescription": "Cette ouverture exceptionnelle sera définitivement supprimée.",
    "OpeningHours.openingsFound": "ouverture(s)",
    "ExceptionalOpening.addTitle": "Ajouter une ouverture exceptionnelle",
    "ExceptionalOpening.editTitle": "Modifier l'ouverture exceptionnelle",
    "ExceptionalOpening.dateLabel": "Date",
    "ExceptionalOpening.dateValidation": "Veuillez sélectionner un jour normalement fermé",
    "ExceptionalOpening.hoursLabel": "Heures d'ouverture",
    "ExceptionalOpening.hoursSourceEmployee": "D'après l'horaire habituel du {day} pour {name}.",
    "ExceptionalOpening.hoursSourceSalon": "D'après l'horaire du salon le {day}.",
    "ExceptionalOpening.hoursSourceDefault": "Heures par défaut, à vérifier.",
    "ExceptionalOpening.reasonLabel": "Raison (optionnel)",
    "ExceptionalOpening.reasonPlaceholder": "ex: Événement spécial, Disponibilité supplémentaire...",
    "ExceptionalOpening.recurring": "Récurrent",
    "ExceptionalOpening.recurringDescription": "Répéter cette ouverture sur plusieurs dates",
    "ExceptionalOpening.repeatEvery": "Répéter tous les",
    "ExceptionalOpening.weeks": "semaine(s)",
    "ExceptionalOpening.months": "mois",
    "ExceptionalOpening.until": "Jusqu'au",
    "ExceptionalOpening.willCreate": "Créera",
    "ExceptionalOpening.openings": "ouverture(s)",
    "ExceptionalOpening.saved": "Ouverture exceptionnelle enregistrée avec succès",
    "ExceptionalOpening.saveError": "Échec de l'enregistrement de l'ouverture exceptionnelle",
    "ExceptionalOpening.onlyClosedDays": "Seuls les jours normalement fermés peuvent être sélectionnés",
    "ExceptionalOpening.conflictItemAll": "Tous les employés le {date}",
    "ExceptionalOpening.conflictItemOne": "{name} le {date}",
    "ExceptionalOpening.conflictToastOne": "Déjà ouvert : {label}. Modifiez l'entrée existante depuis le calendrier.",
    "ExceptionalOpening.conflictToastMany": "{count} ouvertures déjà existantes (ex : {label}). Modifiez depuis le calendrier.",
    "ExceptionalOpening.replaceTitle": "Une ouverture existe déjà",
    "ExceptionalOpening.replaceDescOne": "Une ouverture exceptionnelle existe déjà pour {label} ({existing}). La remplacer par {new} ?",
    "ExceptionalOpening.replaceDescMany": "{count} ouvertures existent déjà pour ces dates. Les remplacer par les nouvelles heures ({new}) ?",
    "ExceptionalOpening.replaceConfirm": "Remplacer",
    "ExceptionalOpening.groupManagement": "Groupe d'ouvertures exceptionnelles",
    "ExceptionalOpening.groupDialogDescription":
      "Toutes les lignes couvertes par cette ouverture. Sélectionnez celles à retirer, ou modifiez-en une seule.",
    "ExceptionalOpening.employeesCovered": "Employés couverts",
    "ExceptionalOpening.confirmDeleteSelectedDescription": "Êtes-vous sûr de vouloir supprimer les ouvertures exceptionnelles sélectionnées ?",
    "ExceptionalOpening.deleteSuccessMultiple": "ouvertures exceptionnelles supprimées",
    "OpeningHours.groupEditHeading": "Modifier les heures et la raison de cette entrée",
    "OpeningHours.groupEditApplyHint": "S'applique aux {n} lignes ci-dessous.",
    "OpeningHours.groupEditApplyHintOne": "S'applique à la ligne ci-dessous.",
    "OpeningHours.selectAtLeastOneRow": "Sélectionnez au moins une ligne",
    "OpeningHours.exceptionalOpening": "Ouverture exceptionnelle",

    // Exceptional Hours (modify hours on open days)
    "OpeningHours.exceptionalHours": "Horaires exceptionnels",
    "OpeningHours.exceptionalHoursDescription": "Modifier les horaires des jours normalement ouverts",
    "OpeningHours.tabSchedule": "Horaires",
    "OpeningHours.tabExceptions": "Exceptions",
    "OpeningHours.tabEmployees": "Par employé",
    "OpeningHours.headerSubtitle": "Horaires du salon, horaires par employé et exceptions.",
    "OpeningHours.tileOpenDays": "Jours ouverts",
    "OpeningHours.tileIndividual": "Horaires perso",
    "OpeningHours.tileEnabled": "Activés",
    "OpeningHours.tileDisabled": "Désactivés",
    "OpeningHours.tileExceptionalDays": "Jours except.",
    "OpeningHours.tileClosures": "Fermetures",
    "OpeningHours.addHours": "Ajouter",
    "OpeningHours.noHours": "Aucun horaire exceptionnel programmé",
    "OpeningHours.modifiedHours": "Modifié",
    "OpeningHours.hoursFound": "horaire(s) exceptionnel(s)",
    "OpeningHours.confirmDeleteHours": "Supprimer les horaires exceptionnels ?",
    "OpeningHours.confirmDeleteHoursDescription": "Cette action est irréversible.",
    "OpeningHours.hoursDeleted": "Horaires exceptionnels supprimés avec succès",
    "ExceptionalHours.addTitle": "Ajouter des horaires exceptionnels",
    "ExceptionalHours.editTitle": "Modifier les horaires exceptionnels",
    "ExceptionalHours.normalHours": "Horaires normaux",
    "ExceptionalHours.newHours": "Nouveaux horaires",
    "ExceptionalHours.onlyOpenDays": "Seuls les jours normalement ouverts peuvent être sélectionnés",
    "ExceptionalHours.reasonPlaceholder": "ex: Événement spécial, Horaires prolongés...",
    "ExceptionalDays.title": "Jours exceptionnels",
    "ExceptionalDays.description": "Gérez les ouvertures spéciales et les horaires modifiés",
    "ExceptionalDays.addTitle": "Ajouter un jour exceptionnel",
    "ExceptionalDays.editTitle": "Modifier un jour exceptionnel",
    "ExceptionalDays.badgeOpening": "Ouverture spéciale",
    "ExceptionalDays.badgeExtended": "Horaire modifié",
    "ExceptionalDays.dayNormallyClosed": "Ce jour est normalement fermé",
    "ExceptionalDays.dayNormallyOpen": "Ce jour est normalement ouvert",
    "ExceptionalDays.empty": "Aucun jour exceptionnel prévu",
    "ExceptionalDays.count": "jour(s) exceptionnel(s)",
    "ExceptionalDays.filterOpenings": "Ouvertures spéciales",
    "ExceptionalDays.filterExtended": "Horaires modifiés",

    // OpeningHours
    "OpeningHours.title": "Heures d'ouverture",
    "OpeningHours.subtitle":
      "Définissez l'horaire hebdomadaire de votre salon. Activez/désactivez les jours et ajustez les heures.",
    "OpeningHours.monday": "Lundi",
    "OpeningHours.tuesday": "Mardi",
    "OpeningHours.wednesday": "Mercredi",
    "OpeningHours.thursday": "Jeudi",
    "OpeningHours.friday": "Vendredi",
    "OpeningHours.saturday": "Samedi",
    "OpeningHours.sunday": "Dimanche",
    "OpeningHours.start": "Heure de début",
    "OpeningHours.end": "Heure de fin",
    "OpeningHours.to": "à",
    "OpeningHours.closed": "Fermé",

    // Horaires rotatifs
    "Schedule.weekLabel": "Semaine",
    "Schedule.addWeek": "Ajouter une semaine",
    "Schedule.removeWeek": "Supprimer cette semaine",
    "Schedule.removeWeekConfirm": "Êtes-vous sûr de vouloir supprimer cette semaine de la rotation?",
    "Schedule.cycleStart": "Date de début du cycle",
    "Schedule.cycleStartMondayOnly": "Le cycle démarre toujours un lundi.",
    "Schedule.currentWeek": "En cours",
    "Schedule.rotatingSchedule": "Horaire rotatif",
    "Schedule.weekCount": "rotation de semaines",
    "Schedule.autoCalculate": "Calculer depuis l'horaire",
    "Schedule.removeWeekTitle": "Supprimer la {week} ?",
    "Schedule.removeWeekDescription": "Ses 7 journées seront perdues.",
    "Schedule.removeWeekWithEmployees": "Ses 7 journées seront perdues, pour le salon et pour {n} employés.",
    "Schedule.removeWeekWithEmployee": "Ses 7 journées seront perdues, pour le salon et pour {n} employé.",
    "Schedule.rotationIntroTitle": "Mettre en place un horaire alterné ?",
    "Schedule.rotationIntroDescription": "Une rotation se répète semaine après semaine, indéfiniment. Pour une ouverture ou une fermeture ponctuelle, passez plutôt par l'onglet Exceptions.",
    "Schedule.rotationIntroWeekOne": "La semaine du lundi {date} sera la semaine A.",
    "Schedule.rotationIntroConfirm": "Ajouter la semaine",
    "OpeningHours.cycleStartInFuture": "La date de début du cycle est dans le futur pour {name}. Choisissez le lundi de cette semaine ou un lundi antérieur.",
    "OpeningHours.cycleStartInFutureSalon": "La date de début du cycle du salon est dans le futur. Choisissez le lundi de cette semaine ou un lundi antérieur.",
    "OpeningHours.theSalon": "le salon",
    "OpeningHours.conflictingOpeningsTitle": "Des ouvertures exceptionnelles tombent maintenant sur des journées ouvertes",
    "OpeningHours.conflictingOpeningsDescription": "Une ouverture exceptionnelle remplace toujours l'horaire habituel. Si vous les gardez, ces journées suivront leurs heures à elles, pas votre nouvel horaire.",
    "OpeningHours.conflictingOpeningsNoPermission": "Vous n'avez pas le droit de gérer les jours exceptionnels. Demandez au propriétaire de retirer ces ouvertures depuis l'onglet Exceptions.",
    "OpeningHours.conflictingOpeningsLineOne": "{name} : 1 ouverture exceptionnelle tombe maintenant sur une journée ouverte{differ}.",
    "OpeningHours.conflictingOpeningsLine": "{name} : {n} ouvertures exceptionnelles tombent maintenant sur des journées ouvertes{differ}.",
    "OpeningHours.conflictingOpeningsDifferSingle": ", avec d'autres heures",
    "OpeningHours.conflictingOpeningsDifferOne": ", dont 1 avec d'autres heures",
    "OpeningHours.conflictingOpeningsDiffer": ", dont {m} avec d'autres heures",
    "OpeningHours.conflictingOpeningsRemove": "Retirer ces ouvertures",
    "OpeningHours.conflictingOpeningsKeep": "Les garder",
    "OpeningHours.conflictingOpeningsRemoveFailed": "Votre horaire est enregistré, mais les ouvertures exceptionnelles n'ont pas pu être retirées. Retirez-les depuis l'onglet Exceptions.",
    "OpeningHours.personOverlap": "Cette plage chevauche {start} à {end} à {location}. {name} ne peut pas être à deux endroits en même temps.",
    "OpeningHours.personGridSubtitle": "Horaire de {name} dans toutes ses succursales. Chaque plage appartient à une succursale.",
    "OpeningHours.personAddSlot": "Plage",
    "OpeningHours.personAddSlotAt": "Ajouter une plage à {location}",
    "OpeningHours.personSlotLocation": "Succursale de cette plage",
    "OpeningHours.personSlotLocked": "Vous ne pouvez pas modifier l'horaire de {location}.",
    "OpeningHours.personRemoveSlot": "Retirer cette plage",
    "OpeningHours.personWeekCountLocked": "Seule une personne qui gère toutes ces succursales peut ajouter ou retirer une semaine.",
    "OpeningHours.personPartialSave": "Horaire de {name} enregistré pour {saved}. Non enregistré pour {failed} : veuillez réessayer.",
    "OpeningHours.personNoneSaved": "Horaire de {name} non enregistré pour {failed} : veuillez réessayer.",
    "OpeningHours.personOtherLocation": "Autre succursale",
    "OpeningHours.personLoadFailed": "L'horaire des autres succursales de votre personnel n'a pas pu être lu.",
  },
};
